import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "clockWithChipInside",
    iconColor: "white",
    text: "Slash activation \ntime",
    listItemCustomStyle: { width: "210px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithChessPiece",
    iconColor: "white",
    text: "Precision and \nperfection in \neliminating errors",
    listItemCustomStyle: { width: "269px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "rocketAndHandWithCoin",
    iconColor: "white",
    text: "Boost efficiency and \nresource savings",
    listItemCustomStyle: { width: "246px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_INLCM_4 = {
  title: "Seamless Network Activation",
  titleNumber: "4.",
  text: "Activate, verify, and streamline; automating activation with accuracy.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage("ENG_306"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_304"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_INTRO_05.jpg",
};
